module.exports = __webpack_public_path__ + "media/escudos/logo_MIMP-bd299c34.png";